// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateDictionaryEntryRequestV2Dto } from '../models';
// @ts-ignore
import type { CreateDictionaryV2ResponseDto } from '../models';
// @ts-ignore
import type { DictionaryEntryDto } from '../models';
// @ts-ignore
import type { DictionaryTranslationDto } from '../models';
// @ts-ignore
import type { DictionaryTypeDto } from '../models';
// @ts-ignore
import type { GetOcdLocationsResponseDto } from '../models';
// @ts-ignore
import type { TranslateDictionaryRequestV2Dto } from '../models';
// @ts-ignore
import type { UpdateDictionaryEntryStateV2RequestDto } from '../models';
// @ts-ignore
import type { UpdateDictionaryV2RequestDto } from '../models';
/**
 * DictionariesV2Api - axios parameter creator
 */
export const DictionariesV2ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new dictionary entry
         * @param {CreateDictionaryEntryRequestV2Dto} createDictionaryEntryRequestV2Dto Data needed to create dictionary entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDictionaryEntry: async (createDictionaryEntryRequestV2Dto: CreateDictionaryEntryRequestV2Dto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDictionaryEntryRequestV2Dto' is not null or undefined
            assertParamExists('createDictionaryEntry', 'createDictionaryEntryRequestV2Dto', createDictionaryEntryRequestV2Dto)
            const localVarPath = `/api/v2/dictionaries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDictionaryEntryRequestV2Dto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List dictionaries
         * @param {DictionaryTypeDto} [type] 
         * @param {boolean} [approved] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDictionaries: async (type?: DictionaryTypeDto, approved?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/dictionaries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (approved !== undefined) {
                localVarQueryParameter['approved'] = approved;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get dictionary entry
         * @param {number} dictionaryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDictionaryEntry: async (dictionaryId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dictionaryId' is not null or undefined
            assertParamExists('getDictionaryEntry', 'dictionaryId', dictionaryId)
            const localVarPath = `/api/v2/dictionaries/{dictionaryId}`
                .replace('{dictionaryId}', encodeURIComponent(String(dictionaryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List OCD locations used by user profiles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOcdLocations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/dictionaries/ocd-locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Translate dictionary text
         * @param {TranslateDictionaryRequestV2Dto} translateDictionaryRequestV2Dto Data needed to translate text
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        translateDictionaryText: async (translateDictionaryRequestV2Dto: TranslateDictionaryRequestV2Dto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'translateDictionaryRequestV2Dto' is not null or undefined
            assertParamExists('translateDictionaryText', 'translateDictionaryRequestV2Dto', translateDictionaryRequestV2Dto)
            const localVarPath = `/api/v2/dictionaries/translate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(translateDictionaryRequestV2Dto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update dictionary entry
         * @param {number} dictionaryId 
         * @param {UpdateDictionaryV2RequestDto} updateDictionaryV2RequestDto Data needed to perform operations on the dictionary entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDictionaryEntry: async (dictionaryId: number, updateDictionaryV2RequestDto: UpdateDictionaryV2RequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dictionaryId' is not null or undefined
            assertParamExists('updateDictionaryEntry', 'dictionaryId', dictionaryId)
            // verify required parameter 'updateDictionaryV2RequestDto' is not null or undefined
            assertParamExists('updateDictionaryEntry', 'updateDictionaryV2RequestDto', updateDictionaryV2RequestDto)
            const localVarPath = `/api/v2/dictionaries/{dictionaryId}`
                .replace('{dictionaryId}', encodeURIComponent(String(dictionaryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDictionaryV2RequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update dictionary entry state
         * @param {number} dictionaryId 
         * @param {UpdateDictionaryEntryStateV2RequestDto} updateDictionaryEntryStateV2RequestDto Data needed to update dictionary entry state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDictionaryEntryState: async (dictionaryId: number, updateDictionaryEntryStateV2RequestDto: UpdateDictionaryEntryStateV2RequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dictionaryId' is not null or undefined
            assertParamExists('updateDictionaryEntryState', 'dictionaryId', dictionaryId)
            // verify required parameter 'updateDictionaryEntryStateV2RequestDto' is not null or undefined
            assertParamExists('updateDictionaryEntryState', 'updateDictionaryEntryStateV2RequestDto', updateDictionaryEntryStateV2RequestDto)
            const localVarPath = `/api/v2/dictionaries/{dictionaryId}`
                .replace('{dictionaryId}', encodeURIComponent(String(dictionaryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDictionaryEntryStateV2RequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DictionariesV2Api - functional programming interface
 */
export const DictionariesV2ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DictionariesV2ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create new dictionary entry
         * @param {CreateDictionaryEntryRequestV2Dto} createDictionaryEntryRequestV2Dto Data needed to create dictionary entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDictionaryEntry(createDictionaryEntryRequestV2Dto: CreateDictionaryEntryRequestV2Dto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateDictionaryV2ResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDictionaryEntry(createDictionaryEntryRequestV2Dto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionariesV2Api.createDictionaryEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List dictionaries
         * @param {DictionaryTypeDto} [type] 
         * @param {boolean} [approved] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDictionaries(type?: DictionaryTypeDto, approved?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DictionaryEntryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDictionaries(type, approved, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionariesV2Api.getDictionaries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get dictionary entry
         * @param {number} dictionaryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDictionaryEntry(dictionaryId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DictionaryEntryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDictionaryEntry(dictionaryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionariesV2Api.getDictionaryEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List OCD locations used by user profiles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOcdLocations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOcdLocationsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOcdLocations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionariesV2Api.getOcdLocations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Translate dictionary text
         * @param {TranslateDictionaryRequestV2Dto} translateDictionaryRequestV2Dto Data needed to translate text
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async translateDictionaryText(translateDictionaryRequestV2Dto: TranslateDictionaryRequestV2Dto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DictionaryTranslationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.translateDictionaryText(translateDictionaryRequestV2Dto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionariesV2Api.translateDictionaryText']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update dictionary entry
         * @param {number} dictionaryId 
         * @param {UpdateDictionaryV2RequestDto} updateDictionaryV2RequestDto Data needed to perform operations on the dictionary entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDictionaryEntry(dictionaryId: number, updateDictionaryV2RequestDto: UpdateDictionaryV2RequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDictionaryEntry(dictionaryId, updateDictionaryV2RequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionariesV2Api.updateDictionaryEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update dictionary entry state
         * @param {number} dictionaryId 
         * @param {UpdateDictionaryEntryStateV2RequestDto} updateDictionaryEntryStateV2RequestDto Data needed to update dictionary entry state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDictionaryEntryState(dictionaryId: number, updateDictionaryEntryStateV2RequestDto: UpdateDictionaryEntryStateV2RequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDictionaryEntryState(dictionaryId, updateDictionaryEntryStateV2RequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionariesV2Api.updateDictionaryEntryState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DictionariesV2Api - factory interface
 */
export const DictionariesV2ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DictionariesV2ApiFp(configuration)
    return {
        /**
         * 
         * @summary Create new dictionary entry
         * @param {CreateDictionaryEntryRequestV2Dto} createDictionaryEntryRequestV2Dto Data needed to create dictionary entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDictionaryEntry(createDictionaryEntryRequestV2Dto: CreateDictionaryEntryRequestV2Dto, options?: RawAxiosRequestConfig): AxiosPromise<CreateDictionaryV2ResponseDto> {
            return localVarFp.createDictionaryEntry(createDictionaryEntryRequestV2Dto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List dictionaries
         * @param {DictionaryTypeDto} [type] 
         * @param {boolean} [approved] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDictionaries(type?: DictionaryTypeDto, approved?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<DictionaryEntryDto>> {
            return localVarFp.getDictionaries(type, approved, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get dictionary entry
         * @param {number} dictionaryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDictionaryEntry(dictionaryId: number, options?: RawAxiosRequestConfig): AxiosPromise<DictionaryEntryDto> {
            return localVarFp.getDictionaryEntry(dictionaryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List OCD locations used by user profiles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOcdLocations(options?: RawAxiosRequestConfig): AxiosPromise<GetOcdLocationsResponseDto> {
            return localVarFp.getOcdLocations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Translate dictionary text
         * @param {TranslateDictionaryRequestV2Dto} translateDictionaryRequestV2Dto Data needed to translate text
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        translateDictionaryText(translateDictionaryRequestV2Dto: TranslateDictionaryRequestV2Dto, options?: RawAxiosRequestConfig): AxiosPromise<Array<DictionaryTranslationDto>> {
            return localVarFp.translateDictionaryText(translateDictionaryRequestV2Dto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update dictionary entry
         * @param {number} dictionaryId 
         * @param {UpdateDictionaryV2RequestDto} updateDictionaryV2RequestDto Data needed to perform operations on the dictionary entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDictionaryEntry(dictionaryId: number, updateDictionaryV2RequestDto: UpdateDictionaryV2RequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateDictionaryEntry(dictionaryId, updateDictionaryV2RequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update dictionary entry state
         * @param {number} dictionaryId 
         * @param {UpdateDictionaryEntryStateV2RequestDto} updateDictionaryEntryStateV2RequestDto Data needed to update dictionary entry state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDictionaryEntryState(dictionaryId: number, updateDictionaryEntryStateV2RequestDto: UpdateDictionaryEntryStateV2RequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateDictionaryEntryState(dictionaryId, updateDictionaryEntryStateV2RequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DictionariesV2Api - interface
 */
export interface DictionariesV2ApiInterface {
    /**
     * 
     * @summary Create new dictionary entry
     * @param {CreateDictionaryEntryRequestV2Dto} createDictionaryEntryRequestV2Dto Data needed to create dictionary entry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createDictionaryEntry(createDictionaryEntryRequestV2Dto: CreateDictionaryEntryRequestV2Dto, options?: RawAxiosRequestConfig): AxiosPromise<CreateDictionaryV2ResponseDto>;

    /**
     * 
     * @summary List dictionaries
     * @param {DictionaryTypeDto} [type] 
     * @param {boolean} [approved] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDictionaries(type?: DictionaryTypeDto, approved?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<DictionaryEntryDto>>;

    /**
     * 
     * @summary Get dictionary entry
     * @param {number} dictionaryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDictionaryEntry(dictionaryId: number, options?: RawAxiosRequestConfig): AxiosPromise<DictionaryEntryDto>;

    /**
     * 
     * @summary List OCD locations used by user profiles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOcdLocations(options?: RawAxiosRequestConfig): AxiosPromise<GetOcdLocationsResponseDto>;

    /**
     * 
     * @summary Translate dictionary text
     * @param {TranslateDictionaryRequestV2Dto} translateDictionaryRequestV2Dto Data needed to translate text
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    translateDictionaryText(translateDictionaryRequestV2Dto: TranslateDictionaryRequestV2Dto, options?: RawAxiosRequestConfig): AxiosPromise<Array<DictionaryTranslationDto>>;

    /**
     * 
     * @summary Update dictionary entry
     * @param {number} dictionaryId 
     * @param {UpdateDictionaryV2RequestDto} updateDictionaryV2RequestDto Data needed to perform operations on the dictionary entry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateDictionaryEntry(dictionaryId: number, updateDictionaryV2RequestDto: UpdateDictionaryV2RequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update dictionary entry state
     * @param {number} dictionaryId 
     * @param {UpdateDictionaryEntryStateV2RequestDto} updateDictionaryEntryStateV2RequestDto Data needed to update dictionary entry state
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateDictionaryEntryState(dictionaryId: number, updateDictionaryEntryStateV2RequestDto: UpdateDictionaryEntryStateV2RequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * DictionariesV2Api - object-oriented interface
 */
export class DictionariesV2Api extends BaseAPI implements DictionariesV2ApiInterface {
    /**
     * 
     * @summary Create new dictionary entry
     * @param {CreateDictionaryEntryRequestV2Dto} createDictionaryEntryRequestV2Dto Data needed to create dictionary entry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createDictionaryEntry(createDictionaryEntryRequestV2Dto: CreateDictionaryEntryRequestV2Dto, options?: RawAxiosRequestConfig) {
        return DictionariesV2ApiFp(this.configuration).createDictionaryEntry(createDictionaryEntryRequestV2Dto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List dictionaries
     * @param {DictionaryTypeDto} [type] 
     * @param {boolean} [approved] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDictionaries(type?: DictionaryTypeDto, approved?: boolean, options?: RawAxiosRequestConfig) {
        return DictionariesV2ApiFp(this.configuration).getDictionaries(type, approved, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get dictionary entry
     * @param {number} dictionaryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDictionaryEntry(dictionaryId: number, options?: RawAxiosRequestConfig) {
        return DictionariesV2ApiFp(this.configuration).getDictionaryEntry(dictionaryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List OCD locations used by user profiles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOcdLocations(options?: RawAxiosRequestConfig) {
        return DictionariesV2ApiFp(this.configuration).getOcdLocations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Translate dictionary text
     * @param {TranslateDictionaryRequestV2Dto} translateDictionaryRequestV2Dto Data needed to translate text
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public translateDictionaryText(translateDictionaryRequestV2Dto: TranslateDictionaryRequestV2Dto, options?: RawAxiosRequestConfig) {
        return DictionariesV2ApiFp(this.configuration).translateDictionaryText(translateDictionaryRequestV2Dto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update dictionary entry
     * @param {number} dictionaryId 
     * @param {UpdateDictionaryV2RequestDto} updateDictionaryV2RequestDto Data needed to perform operations on the dictionary entry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateDictionaryEntry(dictionaryId: number, updateDictionaryV2RequestDto: UpdateDictionaryV2RequestDto, options?: RawAxiosRequestConfig) {
        return DictionariesV2ApiFp(this.configuration).updateDictionaryEntry(dictionaryId, updateDictionaryV2RequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update dictionary entry state
     * @param {number} dictionaryId 
     * @param {UpdateDictionaryEntryStateV2RequestDto} updateDictionaryEntryStateV2RequestDto Data needed to update dictionary entry state
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateDictionaryEntryState(dictionaryId: number, updateDictionaryEntryStateV2RequestDto: UpdateDictionaryEntryStateV2RequestDto, options?: RawAxiosRequestConfig) {
        return DictionariesV2ApiFp(this.configuration).updateDictionaryEntryState(dictionaryId, updateDictionaryEntryStateV2RequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

